import React from 'react'
import { useTranslation } from 'react-i18next'
import Zoom from 'react-reveal/Zoom'

const Video = () => {
	const { t } = useTranslation()
	return (
		<section className='bg-main-dark py-10'>
			<Zoom top>
				<h2
					className='text-xl md:font-bold md:text-5xl text-main-secondary text-center py-8'
					id='participation'
				>
					{t('translation:video:title')}
				</h2>
			</Zoom>
			<Zoom bottom>
				<div className='video-wrapper w-full md:w-8/12 mr-auto ml-auto border-2 border-main-primary'>
					<div className='video-container'>
						<iframe
							src='https://www.youtube.com/embed/nIHKq6Uc7Vg'
							title='Betish'
							frameBorder='0'
							allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
							allowFullScreen
						></iframe>
					</div>
				</div>
			</Zoom>
		</section>
	)
}

export default Video
